import { render, staticRenderFns } from "./BetTotoSlider.vue?vue&type=template&id=6309ded2&scoped=true"
import script from "./BetTotoSlider.vue?vue&type=script&lang=js"
export * from "./BetTotoSlider.vue?vue&type=script&lang=js"
import style0 from "./BetTotoSlider.vue?vue&type=style&index=0&id=6309ded2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6309ded2",
  null
  
)

export default component.exports